var exports = {
  "HX": "xcc377c0b--06724f--basic",
  "bE": "xcc377c0b--06724f--basic-section",
  "x$": "xcc377c0b--06724f--basic-top",
  "xm": "xcc377c0b--06724f--basic-content",
  "iZ": "xcc377c0b--06724f--developerSiteLink",
  "MH": "xcc377c0b--06724f--developerSiteLink-icon",
};

module.exports = exports;
